import React, { type FC } from 'react'
import { Tag } from 'antd'
import { Dismiss16Regular } from '@fluentui/react-icons'

interface IInfoTagProps {
  text: string
  onClose: () => void
}

export const InfoTag: FC<IInfoTagProps> = ({ text, onClose }) => {
  return (
    <Tag
      closeIcon={<Dismiss16Regular />}
      aria-label='Info Tag'
      className='info-tag'
      onClose={onClose}>
      {text}
    </Tag>
  )
}
